// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e4k63","footer":"styles_footer__3SzHc","passCodeTooltip":"styles_passCodeTooltip__2G95n"};